import React from "react";

const ActiveCellTemplate = (value, column) => {
  return <i className={`pi pi-${value[column.field] ? "check" : "times"}`} />;
};

export default ActiveCellTemplate;
